var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.list),function(item,i){return _c('a',{key:i,class:{ active: _vm.cur === i },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.cur = i
      _vm.$emit('change', i, item)}}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }